var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--shared_hero w-100"
  }, [_c('div', {
    staticClass: "tw-overflow-hidden tw-relative tw-bg-contain",
    style: _vm.bannerStyle
  }, [_vm.$slots.default ? [_vm.$slots ? _c('div', {
    staticClass: "tw-w-full tw-centered-x tw-z-20 tw-top-10 md:tw-top-15"
  }, [_vm._t("default")], 2) : _vm._e()] : _vm._e(), _vm._v(" "), _vm.$slots.second ? [_vm._t("second")] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tw-w-full tw-h-full tw-relative tw-z-10 tw-flex tw-justify-center"
  }, [_c('nuxt-img', {
    class: [_vm.imageClass, _vm.imageHeightClass],
    attrs: {
      "src": _vm.url,
      "width": _vm.imageWidth,
      "height": _vm.imageHeight,
      "alt": _vm.altText,
      "loading": "eager"
    }
  })], 1)], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }